import { CognitoAuth } from 'amazon-cognito-auth-js/dist/amazon-cognito-auth'
import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { config as AWSConfig } from 'aws-sdk'
import appConfig from '../config/app-config.json'
var env = process.env;
AWSConfig.region = process.env.REACT_APP_cognito_region



// Creates a CognitoAuth instance
const createCognitoAuth = () => {
  console.log('env-------', env);

  


  const appWebDomain = process.env.REACT_APP_cognito_userPoolBaseUri.replace('https://', '').replace('http://', '')
   let tokenScopes =  appConfig.tokenScopes;
   tokenScopes.push(process.env.REACT_APP_cognito_tokenScopes)
   console.log('tokenScopes-------', tokenScopes);
  const auth = new CognitoAuth({
    UserPoolId: process.env.REACT_APP_cognito_userPool,
    ClientId: process.env.REACT_APP_cognito_clientId,
    AppWebDomain: appWebDomain,
    TokenScopesArray: tokenScopes,
    RedirectUriSignIn: process.env.REACT_APP_cognito_callbackUri,
    RedirectUriSignOut: process.env.REACT_APP_cognito_signoutUri
  })
  return auth
}

// Creates a CognitoUser instance
const createCognitoUser = () => {
  const pool = createCognitoUserPool()
  return pool.getCurrentUser()
}

// Creates a CognitoUserPool instance
const createCognitoUserPool = () => new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_cognito_userPool,
  ClientId: process.env.REACT_APP_cognito_clientId
})

// Get the URI of the hosted sign in screen
const getCognitoSignInUri = () => {
  console.log('env--->', process.env.REACT_APP_cognito_userPoolBaseUri);

  const signinUri = `${process.env.REACT_APP_cognito_userPoolBaseUri}/login?response_type=code&client_id=${process.env.REACT_APP_cognito_clientId}&redirect_uri=${process.env.REACT_APP_cognito_callbackUri}`
  return signinUri
}

// Parse the response from a Cognito callback URI (assumed a token or code is in the supplied href). Returns a promise.
const parseCognitoWebResponse = (href) => {
  return new Promise((resolve, reject) => {
    const auth = createCognitoAuth()

    // userHandler will trigger the promise
    auth.userhandler = {
      onSuccess: function (result) {
        resolve(result)
      },
      onFailure: function (err) {
        reject(new Error('Failure parsing Cognito web response: ' + err))
      }
    }
    auth.parseCognitoWebResponse(href)
  })
}

// Gets a new Cognito session. Returns a promise.
const getCognitoSession = () => {
  return new Promise((resolve, reject) => {
    const cognitoUser = createCognitoUser()
    cognitoUser.getSession((err, result) => {
      if (err || !result) {
        reject(new Error('Failure getting Cognito session: ' + err))
        return
      }

      // Resolve the promise with the session credentials
      console.debug('Successfully got session: ' + JSON.stringify(result))
      const session = {
        credentials: {
          accessToken: result.accessToken.jwtToken,
          idToken: result.idToken.jwtToken,
          refreshToken: result.refreshToken.token
        },
        user: {
          userName: result.idToken.payload['cognito:username'],
          email: result.idToken.payload.email
        }
      }
      resolve(session)
    })
  })
}

// Sign out of the current session (will redirect to signout URI)
const signOutCognitoSession = () => {
  const auth = createCognitoAuth()
  auth.signOut()
}

export default {
  createCognitoAuth,
  createCognitoUser,
  createCognitoUserPool,
  getCognitoSession,
  getCognitoSignInUri,
  parseCognitoWebResponse,
  signOutCognitoSession
}
